export default __webpack_public_path__ + "static/media/canada.1e2bf5c7.png";